import { render, staticRenderFns } from "./IdentityCollect.vue?vue&type=template&id=23492ac0&"
import script from "./IdentityCollect.vue?vue&type=script&lang=js&"
export * from "./IdentityCollect.vue?vue&type=script&lang=js&"
import style0 from "./IdentityCollect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports